/**
 * 盒子-底部信息
 * @author VenDream
 * @since 18/03/23
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
import { showRabbitBrandInfo } from 'utils/user';
import QRCode from '@fe/common/lib/qrcode';
import './tpl-info.less';
import { initSSO } from 'components/sso/sso';
import VARIABLES from 'constants/variable.json5';
// import { userInfo } from 'reducers';
initSSO(data => {
  if (data) window.userInfo = data;
});
// 二维码配置
const QRCODE_CONFIG = {
  // 宽度
  width: 124,
  // 高度
  height: 124,
  // 前景色
  colorDark: '#000000',
  // 背景色
  colorLight: '#ffffff',
};

class TplInfo extends Component {
  static propTypes = {
    tpl: PropTypes.object,
    style: PropTypes.object,
    filters: PropTypes.object,
    onClickBox: PropTypes.func,
    onShowQrCode: PropTypes.func,
    onHideQrCode: PropTypes.func,
    // 是否隐藏底部信息
    hideBottom: PropTypes.bool,
    // 是否是企业专区模板
    isEnterprise: PropTypes.bool,
  };

  static defaultProps = {
    onClickBox: () => {},
    onShowQrCode: () => {},
    onHideQrCode: () => {},
  };

  // 隐藏二维码
  hideQrCode = () => {
    this.infobox.classList.remove('show-qrcode');
    this.props.onHideQrCode();
  };

  // 显示二维码
  showQrCode = () => {
    const { previewUrl } = this.props.tpl;
    const canvas = this.qrCode.querySelector('canvas');

    // 生成二维码
    if (!canvas) {
      new QRCode(this.qrCode, {
        ...QRCODE_CONFIG,
        text: previewUrl,
      });
    }

    this.infobox.classList.add('show-qrcode');
    this.props.onShowQrCode();

    // 二维码hover次数统计
    sendStat(
      'RP_STORE',
      '模版市场',
      '模版封面图二维码大图出现',
      Stat.ACTION_INIT,
      {
        id: 'web_mobanmarket_QRCode_hover',
      }
    );
  };

  render() {
    const {
      tpl,
      style,
      onClickBox,
      filters,
      hideBottom,
      isEnterprise,
    } = this.props;
    const {
      title,
      views,
      price,
      tplPrice,
      pluginId,
      pluginClassifyId,
      type,
      tplOrganizePrice,
    } = tpl;
    let { minimumPrice } = tpl;
    //新接口还要考虑tplOrganizePrice，
    if (tplOrganizePrice !== null && tplOrganizePrice !== undefined) {
      minimumPrice = Math.min(+minimumPrice, +tplOrganizePrice);
    }
    return (
      <div
        className={classnames('tpl-info', { 'hide-bottom': hideBottom })}
        style={style}
        ref={node => (this.infobox = node)}>
        <div className="tpl-hover-panel">
          <div className="qr-code" ref={node => (this.qrCode = node)} />
          <button className="use-btn" onClick={onClickBox}>
            立即使用
          </button>
          {type !== 'POSTER' && showRabbitBrandInfo() ? (
            <span
              className="qr-code-icon"
              title="二维码"
              onMouseEnter={this.showQrCode}
              onMouseLeave={this.hideQrCode}>
              <i className="s-icon icon-QR" />
            </span>
          ) : null}
        </div>
        <div
          className={classnames('tpl-title', {
            'org-tpl-title': isEnterprise && type !== VARIABLES.POSTER,
          })}
          title={title}>
          <div className="flex-wrapper">{title}</div>
        </div>
        {!hideBottom && (
          <div className="tpl-bottom">
            <div className="flex-wrapper">
              {filters.myTplType == 2 && tplPrice > 0 ? (
                <span className="tpl-buy">已购买</span>
              ) : null}
              {tpl.type === VARIABLES.POSTER ? (
                <span></span>
              ) : (
                <span className="tpl-views">
                  <i className="s-icon icon-look" />
                  {views || 0}
                </span>
              )}
              <span
                className={classnames('tpl-price', {
                  'plugin-hide': pluginClassifyId || pluginId,
                })}>
                {minimumPrice < price && filters.myTplType != 2 ? (
                  <span
                    className={classnames('original-price', {
                      'free-type': !minimumPrice,
                    })}>
                    {price.toFixed(2)}元
                  </span>
                ) : null}
                {minimumPrice || (filters.myTplType == 2 && tplPrice > 0) ? (
                  <span className="final-price">
                    {filters.myTplType == 2
                      ? tplPrice.toFixed(2)
                      : minimumPrice.toFixed(2)}
                    元
                  </span>
                ) : (
                  <>
                    {!pluginId && minimumPrice === 0 && (
                      <span className="free">
                        <i className="s-icon icon-label" />
                        免费
                      </span>
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TplInfo;
